import React from 'react';
import { Layout } from 'antd';
import { Link } from 'react-router-dom';
import {
    DiscordFilled
} from '@ant-design/icons'
const { Footer } = Layout;
const AppFooter = () => {
    const supportEmail = 'elimeetagent@gmail.com';

    return (
        <Footer style={{
            textAlign: 'center',
            backgroundColor: '#f0f2f5',
            padding: '15px',
            borderTop: '1px solid #e8e8e8'
        }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '24px' }}>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '24px' }}>
                    <Link to="/privacy">Privacy Policy</Link>
                    <Link to="/terms">Terms of Service</Link>
                    <span>|</span>
                    <span>© 2024 EliCorp. All rights reserved.</span>
                    <span>|</span>
                    <a href={`mailto:${supportEmail}`}>Contact Us</a>
                </div>
                <a
                    href={`https://discord.gg/gXxQgeP6FV`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        color: '#7289DA',
                        textDecoration: 'none',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}
                >
                    <DiscordFilled />
                    Join our Discord Community
                </a>
            </div>
        </Footer>
    );
};

export default AppFooter;